import { PromiseUtils } from './promise';

export const validationOk = { valid: true };
export const validationFail = message => ({ valid: false, message });
export const validation = (valid, message) => ({ valid, message });

export const validationAssert = validationResult => PromiseUtils.assert(validationResult.valid, validationResult.message);
export const validationAssertNot = validationResult => PromiseUtils.assertNot(validationResult.valid, validationResult.message);